import { useChainCoinPrice } from '@/hooks/api/useChainCoinPrice';
import { useLogin } from '@/hooks/api/useLogin';
import { useSolAmountChange } from '@/hooks/api/useSolAmountChange';
import { LangEnum } from '@/lang/enum';
import useLang from '@/hooks/base/useLang';
import React, { ReactNode, useEffect } from 'react';
import { useCalcTotalBalance } from '@/hooks/api/useCalcTotalBalance';
import { useLocation } from 'react-router-dom';

const InitStateContext = ({ children }: { children: ReactNode }) => {
  const { updateLanguage } = useLang();
  const { pathname } = useLocation();
  useLogin();
  useChainCoinPrice(true, 60000);
  useSolAmountChange();
  useCalcTotalBalance();

  useEffect(() => {
    if (pathname.includes('/bsc')) {
      window.localStorage.setItem('chain', 'bsc');
    } else {
      window.localStorage.setItem('chain', 'solana');
    }
  }, [pathname]);

  useEffect(() => {
    window.localStorage.getItem('i18nextLng') == null && window.localStorage.setItem('i18nextLng', LangEnum.EN);
    const currentLang = window.localStorage.getItem('i18nextLng') || LangEnum.EN;
    updateLanguage(currentLang as LangEnum);
  }, []);

  return <React.Fragment>{children}</React.Fragment>;
};

export default InitStateContext;
